import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeftArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.70711 1.70711C9.09763 1.31658 9.09763 0.683417 8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.292893 7.29289C0.181725 7.40406 0.102202 7.53489 0.0543248 7.67419C0.0302327 7.74414 0.0136818 7.81759 0.00564338 7.89359C-0.00188115 7.96431 -0.00188115 8.03569 0.00564339 8.10641C0.0136818 8.18241 0.0302328 8.25586 0.0543248 8.32581C0.102202 8.46511 0.181725 8.59594 0.292893 8.70711L7.29289 15.7071C7.68342 16.0976 8.31658 16.0976 8.70711 15.7071C9.09763 15.3166 9.09763 14.6834 8.70711 14.2929L3.41421 9H15C15.5523 9 16 8.55229 16 8C16 7.44772 15.5523 7 15 7H3.41421L8.70711 1.70711Z",
		fill: "currentColor"
	})
});
export default SvgLeftArrow;
